import { render, staticRenderFns } from "./responsesReject.vue?vue&type=template&id=7cb058dc&"
import script from "./responsesReject.vue?vue&type=script&lang=js&"
export * from "./responsesReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports